
import Vue, { nextTick } from "vue"
import HobbyItem from "@/components/hobby/hobbyItem.vue";
import LayOut from '@/components/layout/index.vue'
import Pagination from '@/components/pagination/index.vue'
import BlogMenu from "@/components/blog/blogMenu.vue";
import { createMainScrollerControl, createRequestMixins, createToTopControl } from "@/mixins";
import { IArticleItem, IBlogCategory } from "blog";
import { HobbyApi } from "@/api";
import Aplayer from 'vue-aplayer'




export default Vue.extend({
	data() {
		return {
			currentItem: null as Partial<IArticleItem> & { audio: string },
			playButton: null as HTMLButtonElement
		}
	},
	components: {
		HobbyItem,
		LayOut,
		BlogMenu,
		Pagination, Aplayer
	},
	mixins: [
		createRequestMixins({
			key: 'hobbyList' as 'hobbyList',
			defaultValue: [] as IArticleItem[]
		}),
		createRequestMixins({
			key: "hobbyMenu" as "hobbyMenu",
			defaultValue: [] as IBlogCategory[]
		}),
		createToTopControl({
			refName: "hobbyContent",
		}),
		createMainScrollerControl({
			refName: "hobbyContent"
		})
	],
	mounted() {
		this.playButton = document.querySelector('.aplayer-icon-play')
	},
	methods: {
		getHobbyList() {
			this.hobbyListLoading = true
			HobbyApi.getHobbyList({ ...this.routeInfo }).then(v => {
				if (v && v.data.total) {
					this.hobbyList = v.data.rows
				}
				console.log(this.hobbyList);

			}).finally(() => {
				this.hobbyListLoading = false
			})
		},
		getHobbyMenu() {
			this.hobbyMenuLoading = true
			HobbyApi.getHobbyMenu().then(v => {
				if (v && v.data.total) {
					this.hobbyMenu = v.data.rows
					console.log(this.hobbyMenu);

				}
			}).finally(() => {
				this.hobbyMenuLoading = false
			})
		},
		blogCategoryChange(item: IBlogCategory) {
			if (+item.id === this.routeInfo.id) {
				return
			}
			if (+item.id === -1) {
				this.$router.push({
					name: 'hobbyIndex'
				})
			} else {
				this.$router.push({
					name: 'hobbyCategory',
					params: {
						id: item.id
					}
				})
			}
		},
		playMusic(item: Partial<IArticleItem> & { audio: string }) {

			if (this.currentItem?.id === item.id) {
				return
			}
			this.currentItem = item

		}
	},
	computed: {
		currentMusic(): IVueAplayerMusic {
			if (!this.currentItem) {
				return {
					src: '',
				}
			}
			const res: IVueAplayerMusic = {
				src: (this.currentItem.audio as any)?.default || this.currentItem.audio,
				title: this.currentItem.title,
				pic: this.currentItem.thumb

			}
			console.log(res, this.currentItem.audio);
			nextTick().then(() => {
				this.playButton.click()
			})
			return res
		},
		categoryWithALL() {
			const all = { id: '-1', name: 'ALL', articleCount: 0, order: '0', isSelected: this.routeInfo.id === -1 } as (IBlogCategory & { isSelected: boolean, aside?: string, articleCount: number })
			const res: (IBlogCategory & { isSelected: boolean, aside?: string })[] = [all]
			for (let i of this.hobbyMenu) {
				res.push({ ...i, isSelected: this.routeInfo.id === +i.id, aside: `${i.articleCount}篇` })
				all.articleCount += +i.articleCount
			}
			all.aside = `${all.articleCount}篇`
			console.log(res);

			return res
		},
		routeInfo() {
			// console.log(this.$route.params, this.$route);
			const { id = -1 } = this.$route.params
			return {
				id: +id,
			}
		},
		displayArticles() {
			const { current, pageSize } = this.paginationData
			return this.hobbyList.filter((x, i) => i >= (current - 1) * pageSize && i < current * pageSize)
		},
	},
	watch: {
		routeInfo(n, o) {
			if (!isRouteChange(n, o)) {
				return
			}
			const { id } = this.routeInfo
			this.getHobbyList()

		},
	}
})
function isRouteChange<T extends {
	id: number;
	page: number;
	limit: number;
}>(newInfo: T, oldInfo: T) {
	for (let i in newInfo) {
		if (newInfo[i] !== oldInfo[i]) {
			return true
		}
	}
	return false
}
